import React, { Fragment } from "react";
import PropTypes from "prop-types";

const Conditional = ({ children, show }) => {
  // const renderChildren = this.props.show ? this.props.children : "";
  // return <Fragment>{renderChildren}</Fragment>;
  if (!show) {
    return false;
  }
  return <Fragment>{children}</Fragment>;
};

export default Conditional;

Conditional.defaultProps = {
  children: [],
};

Conditional.propTypes = {
  children: PropTypes.node,
};
